/**
 * @fileoverview Agent definition for world-event-details-generator-v3.
 *
 * This agent generates complete details for a world event based on a
 * selected creative direction from the details ideation agent.
 *
 * @category world-building.events.details
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'world-event-details-generator-v3',
  kind: 'primitive',
  name: 'World Event Details Generator',
  description: 'Generates complete details for a world event based on a selected creative direction.',
  category: 'world-building',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-02',
    taxonomyPath: 'world-building.events.details',
    usedBy: ['use-world-event-details-generator-v3.ts'],
    usedInComposites: [],
    relatedAgents: [
      'world-event-details-ideation-v3',
      'world-event-snapshotter-v3',
    ],
  },
};
